<template>
    <div @touchstart="$public.blur()" ref="BigMain" @scroll="scrollEvent" class="searchList">
        <navigation-bar Back/>
        <div class="search main" ref="main" @scroll="scrollEvent">
            <!--搜尋input-->
            <search-bar :search="keyword" @searchWord="onKeywordEnter"/>

            <h2 class="title">「{{keyword}}」的 {{totalCount}} 筆結果</h2>

            <div v-if="searchType === 0">
                <article-cover :list="brandList" :shopType="'brand'"/>
            </div>
            <div v-if="searchType === 1 || searchType === 2">
                <article-cover :list="storeList" :showRemark="isShowRemark" :remark="getRemark" :shopType="'store'" hideStar/>
            </div>
            <infinite-loading @infinite="setupDataScroll" ref="infiniteLoading" spinner="waveDots" v-if="setupListData">
                <div slot="no-more">沒有更多資料</div>
                <span slot="no-results"/>
            </infinite-loading>

            <loading
                    :active.sync=isLoading
                    :can-cancel="false"
                    :is-full-page="true">
            </loading>
            <toast/>


        </div>
    </div>
</template>

<script>
    import ArticleCover from '@/components/article/ArticleCover.vue';
    import SearchBar from '../search/components/SearchBar';
    import * as mutationTypes from '@/store/mutationTypes';
    import Toast from "@/components/Toast.vue";


    export default {
        name: "SearchList",
        components: {
            ArticleCover,
            SearchBar,
            Toast,

        },
        data() {
            return {
                isLoading: false,
                searchType: 1,      //大分類, 0:品牌  1:最近店家或最新店家 (本頁固定爲1，所以不會搜尋品牌)
                keyword: this.$route.query.searchText? this.$route.query.searchText:'',   //搜尋的關鍵字
                searchStoreTypeId: this.$route.query.searchStoreTypeId? this.$route.query.searchStoreTypeId: undefined,       //熱門類別的 ID(分類id)
                searchCity: this.$route.query.searchCity? this.$route.query.searchCity:'',             //縣市搜尋
                lng: 0,
                lat: 0,
                pageSize: 10,
                currentPage: 0,
                brandList: [],
                storeList: [],
                setupListData: false,
                infiniteLoadingListState: '',
                scrollTo: '',
                totalCount: 0,
                getTotalCount: true,
            }
        },
        created() {

        },
        mounted() {

            this.setupData();

            window.onresize = () => {
                //電腦版打橫時，載入更多reset
                if (this.$refs.infiniteLoading) {
                    this.$refs.infiniteLoading.stateChanger.reset();
                }
            }
        },
        activated () {
            const fullWidth = window.innerWidth;
            if(fullWidth>=1024){
                //網頁版紀錄捲動位置
                this.$refs.BigMain.scrollTop = this.scrollTop;
            }else{
                //手機版紀錄捲動位置
                this.$refs.main.scrollTop = this.scrollTop;
            }
        },
        beforeRouteLeave: function(to, from, next) {
            this.$store.commit('setLastKeyword', '');
            next();
        },
        watch: {
            keyword: function () {
                //監聽 keyword，只要有重新輸入keyword，就不使用 searchStoreTypeId 和 searchCity 搜尋
                this.searchStoreTypeId = 0;
                this.searchCity = '';
            },
        },
        methods: {

            /** 初始化 */
            init: function() {
                this.currentPage = 0;
                this.brandList = [];
                this.storeList = [];
            },

            /** 初始設定 */
            setupData: function () {
                // 切換tab後先暫停套件，等gps定位完成後再繼續載入，避免載入相同的資料
                if (this.infiniteLoadingListState !== '') {
                    this.infiniteLoadingListState.complete();
                }
                this.init();

                let self = this;
                self.getGpsLocation()
                    .then( () => {
                        self.startLoading();
                    })
                    .catch( (error) => {
                        self.startLoading();
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });

            },

            startLoading() {
                let self = this;
                setTimeout(function(){
                    if(self.infiniteLoadingListState !==  ''){
                        self.infiniteLoadingListState.reset();
                    } else {
                        self.setupListData = true;
                    }
                },100)
            },

            /** 取得GPS位置 */
            getGpsLocation: function () {

                let self = this;
                self.isLoading = true;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        self.lng = position.coords.longitude;
                        self.lat = position.coords.latitude;
                        self.isLoading = false;

                        //結束
                        resolve();
                    };

                    let onError = function (error) {
                        self.isLoading = false;
                        // reject("無法定位GPS");
                        //結束
                        resolve();
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },

            /** 載入更多 */
            setupDataScroll: function ($state) {
                // console.log('## setupDataScroll: ' + JSON.stringify($state));
                let self = this;
                self.infiniteLoadingListState = $state
                self.isLoading = true;
                if (self.searchType === 0){
                    self.getBrandListWithState($state)
                        .then( () => {
                            self.isLoading = false;
                        })
                        .catch( (error) => {
                            this.isLoading = false;
                            self.$store.commit(mutationTypes.SHOW_TOAST, error);
                        });
                } else {
                    self.getStoreListWithState($state)
                        .then( () => {
                            self.isLoading = false;
                        })
                        .catch( (error) => {
                            this.isLoading = false;
                            self.$store.commit(mutationTypes.SHOW_TOAST, error);
                        });
                }
            },

            /** 取得熱門推薦(品牌)列表 */
            getBrandListWithState: function ($state) {
                let self = this;
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`BrandList${{
                        searchType: self.searchType,        // 0: 熱門品牌,  其他: 取得所有品牌
                        storeTypeId: (self.filterTab === null)? undefined: self.filterTab.id,
                        subStoreTypeId: (self.filterTag === null)? undefined: self.filterTag.id,
                    }} ${json => {

                        if (self.$public.notNull(json.data)) {
                            //熱門推薦只顯示20筆
                            if (self.searchType === 0){
                                self.brandList.tmz_load_push(...json.data);
                                $state.complete();
                            }
                            //完成
                            resolve();
                        } else {
                            //失敗
                            reject('失敗');
                        }
                    }}`;
                });
            },
            /** 取得附近店家列表 */
            getStoreListWithState: function ($state) {
                let self = this;

                //如果有傳入 searchStoreTypeId 或 searchCity，就不用 keyword搜尋
                let searchText = self.keyword;
                if (self.searchStoreTypeId > 0 || self.searchCity !== '') {
                    searchText = '';
                }

                return new Promise(function(resolve, reject) {
                    self.$http.fetch`StoreList${{
                        searchType: self.searchType,
                        searchText: searchText,
                        searchStoreTypeId: self.searchStoreTypeId,
                        searchCity: self.searchCity,
                        offset: self.currentPage,
                        lng: self.lng,
                        lat: self.lat,
                        getTotalCount: self.getTotalCount,
                        // storeTypeId: (self.filterTab === null)? undefined: self.filterTab.id,
                        // subStoreTypeId: (self.filterTag === null)? undefined: self.filterTag.id,
                    }} ${json => {

                        if (self.$public.notNull(json.data)) {
                            self.currentPage++;
                            self.storeList.tmz_load_push(...json.data);
                            if (json.data.length >= self.pageSize) {
                                $state.loaded();
                            } else {
                                $state.complete();
                            }

                            if(self.getTotalCount) {
                              self.totalCount = json.totalCount
                              self.getTotalCount = false
                            }


                            //完成
                            resolve();

                        } else {
                            //失敗
                            reject('失敗');
                        }
                    }}`;
                });
            },

            /** 是否顯示備註 */
            isShowRemark: function(storeInfo) {
                let result = false;
                if (this.$public.notNull(storeInfo) && this.$public.notNull(storeInfo.noteStatus) &&
                    this.$public.notNull(storeInfo.title) && this.$public.notNull(storeInfo.notes)) {
                    result = storeInfo.noteStatus &&
                        storeInfo.title !== '' &&
                        storeInfo.notes.length > 0;
                }
                return result ;
            },
            /** 備註 */
            getRemark: function(storeInfo) {
                let result = '';
                if (this.$public.notNull(storeInfo.notes) &&
                    storeInfo.notes.length > 0) {
                    storeInfo.notes.forEach(function (value) {
                        if (value !== '') {
                            result = result + '<p>'+ value ;
                        }
                    })
                }
                return result;
            },

            /** 點擊品牌 */
            onClickBrand: function(brandId) {
                this.$router.push({name: 'BrandInfo', query: {"id": brandId}});
            },

            /** 點擊店家 */
            onClickStore: function(storeId) {
                this.$router.push({name: 'StoreInfo', query: {"id": storeId}});
            },

            /** 關鍵字輸入 */
            onKeywordEnter: function(keyword) {
                this.keyword = keyword;
                this.$store.commit('addSearchRecord', keyword);

                this.getTotalCount = true
                //如果 query的 keyword參數跟目前要搜尋的不一樣，才替換成新的keyword
                if (keyword !== this.$route.query.keyword) {
                    this.$router.replace({ name: `SearchList`, query: {"keyword": this.keyword} });
                }
                //重新搜尋資料
                this.setupData();
            },

            //捲動紀錄位置
            scrollEvent() {
                const fullWidth = window.innerWidth;
                if(fullWidth>=1024){
                    //網頁版紀錄捲動位置
                    this.scrollTop = this.$refs.BigMain.scrollTop;
                }else {
                    //手機版紀錄捲動位置
                    this.scrollTop = this.$refs.main.scrollTop;
                }
            }
        },
    }
</script>

<style lang="less" scoped src="../../less/search.less"/>
